import PropTypes from 'prop-types';
import React from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import _ from 'lodash';

import FootballMatchForm from './FootballMatchForm';

export default function FootballMatchTeamsForm(props) {
  const teamA = _.get(props, 'teamsForm.team_a');
  const teamB = _.get(props, 'teamsForm.team_b');

  if (!teamA && !teamB) {
    return (
      <div className="default-no-article">
        <p>No form data available.</p>
      </div>
    );
  }

  const renderTeamForm = (team) => {
    if (!team || !team.team.name) {
      return null;
    }

    return (
      <React.Fragment>
        <div className= "table-block-header">{team.team.name}</div>
        <FootballMatchForm formMatches={team.matches} />
      </React.Fragment>
    );
  }

  return (
    <div className="footballMatchTeamsForm">
      <MetaDataWrapper title={`${props.matchLabel} - Team Form`}/>
      {renderTeamForm(teamA)}
      {renderTeamForm(teamB)}
      <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
    </div>
  );
}

FootballMatchTeamsForm.propTypes = {
  matchLabel: PropTypes.string,
  teamsForm: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchTeamsForm.js